export default "__VITE_PUBLIC_ASSET__c7db3184__"